import React, { Component } from "react";
import {
  Paper,
  Step,
  Stepper,
  StepLabel,
  StepContent,
  FlatButton,
  RaisedButton,
  MenuItem,
  Subheader,
  Divider,
} from "material-ui";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import Loading from "../Loading";
import Formsy from "formsy-react";
import { FormsySelect } from "formsy-material-ui/lib";
import CyclePreviews from "./CyclePreviews";
import templateEngine from "../../../utils/templateEngine";
import getDateTime from "../../../utils/getDateTime";

export default class EmailBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      finished: false,
      stepIndex: 0,
      stepCount: 3,
      clients: [],
      selectedClients: [],
      templates: [],
      docTypes: [],
      template: {},
      attachments: [],
      documents: [],
      templateSelection: "",
      attachmentSelection: "",
      documentSelection: "",
      response: [],
      checkedCount: 0,
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "65%",
        },
      },
    };

    this.addButtonFormatter = this.addButtonFormatter.bind(this);
    this.removeButtonFormatter = this.removeButtonFormatter.bind(this);
    this.quickAddButtons = this.quickAddButtons.bind(this);
    this.onClickQuickAdd = this.onClickQuickAdd.bind(this);
    this.clearSelected = this.clearSelected.bind(this);
    this.sendEmail = this.sendEmail.bind(this);
    this.renderSelection = this.renderSelection.bind(this);
    this.handleTemplate = this.handleTemplate.bind(this);
    this.handleAttachment = this.handleAttachment.bind(this);
    this.removeAttachment = this.removeAttachment.bind(this);
    this.handleDocument = this.handleDocument.bind(this);
    this.removeDocument = this.removeDocument.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.populateSelections = this.populateSelections.bind(this);
    this.loadTemplates = this.loadTemplates.bind(this);
    this.loadDocTypes = this.loadDocTypes.bind(this);
    this.checkEmail = this.checkEmail.bind(this);
    this.renderAttachment = this.renderAttachment.bind(this);
    this.renderDocument = this.renderDocument.bind(this);
  }

  notifyFormError(data) {
    console.error("Form error:", data);
    alert("Could not save form. Forget to fill out a field?");
  }

  componentWillMount() {
    this.populateSelections();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.workOrders) {
      // let clients = nextProps.workOrders.filter(client => {
      //   return client.status__c == 'Active'
      // })
      // this.setState({clients: clients})
      this.setState({ clients: nextProps.workOrders });
    }
  }

  loadTemplates() {
    return new Promise((resolve, reject) => {
      let url = `/api/templates/getTemplates`;
      let options = {
        headers: {
          token: this.props.token.jwt,
        },
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) return res.json();
        })
        .then((json) => {
          resolve(json);
        });
    });
  }

  loadDocTypes() {
    return new Promise((resolve, reject) => {
      let url = `/api/documentUpload/docTypes`;
      let options = {
        headers: {
          token: this.props.token.jwt,
        },
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) return res.json();
        })
        .then((json) => {
          resolve(json);
        });
    });
  }

  populateSelections() {
    this.props.authFetchWorkorders("clients", this.props.token.jwt);
    let options = {
      headers: {
        token: this.props.token.jwt,
      },
    };
    let p = [];
    p.push(this.loadTemplates());
    p.push(this.loadDocTypes());

    Promise.all(p).then((values) => {
      let templates = values[0].map((att) => {
        att.id = att._id;
        return att;
      });

      this.setState({
        templates: templates,
        docTypes: values[1],
        isLoading: false,
      });
    });
  }

  handleNext = () => {
    const { stepIndex } = this.state;
    this.setState({
      stepIndex: stepIndex + 1,
      finished: stepIndex >= this.state.stepCount,
    });
  };

  handlePrev = () => {
    const { stepIndex } = this.state;
    if (stepIndex > 0) {
      this.setState({ stepIndex: stepIndex - 1 });
    }
  };

  sendEmail() {
    let { selectedClients, template, attachments, documents } = this.state;
    let clients = selectedClients.map((client) => {
      return {
        _id: client._id,
        uid_c: client.uid_c,
      };
    });
    let nagAttachments = attachments.map((attachment) => {
      return attachment._id;
    });
    let nagDocuments = documents.map((doc) => {
      return doc.name;
    });
    this.setState({ isLoading: true });
    let url = "/api/email/queueClientNags";
    let options = {
      method: "POST",
      headers: {
        token: this.props.token.jwt,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        clients: clients,
        templateId: template._id,
        attachments: nagAttachments,
        documents: nagDocuments,
      }),
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({ response: json, isLoading: false });
      });
  }

  renderStepActions() {
    let { stepIndex } = this.state;
    return (
      <div style={{ margin: "12px 0" }}>
        <RaisedButton
          label="Next"
          disableTouchRipple={true}
          disableFocusRipple={true}
          primary={true}
          onTouchTap={this.handleNext}
          style={{ marginRight: 12 }}
          disabled={this.state.selectedClients.length === 0}
        />
        {stepIndex > 0 && (
          <FlatButton
            label="Back"
            disabled={stepIndex === 0}
            disableTouchRipple={true}
            disableFocusRipple={true}
            onTouchTap={this.handlePrev}
          />
        )}
      </div>
    );
  }

  addButtonFormatter(cell, row) {
    const addRow = function (row) {
      let selected = this.state.selectedClients;
      selected.push(row);
      this.setState({ selectedClients: selected });
    };
    let disabled = !(this.state.selectedClients.indexOf(row) < 0);
    return (
      <FlatButton
        disabled={disabled}
        label="Add"
        onClick={addRow.bind(this, row)}
      />
    );
  }

  removeButtonFormatter(cell, row) {
    const removeRow = function (cell) {
      let selected = this.state.selectedClients;
      let newSelected = [];
      delete selected[selected.indexOf(cell)];
      selected.map((sel) => {
        newSelected.push(sel);
      });
      this.setState({ selectedClients: newSelected });
    };
    return (
      <FlatButton
        hoverColor="#ef5350"
        label="Remove"
        onClick={removeRow.bind(this, row)}
      />
    );
  }

  quickAddButtons() {
    let clients = this.state.clients;
    let allTypes = [];
    let buttons = [];
    let clientTypes = clients.reduce((alltypes, client) => {
      if (client.primary_email__c) {
        if (client.record_type__c in allTypes) {
          alltypes[client.record_type__c]++;
        } else {
          alltypes[client.record_type__c] = 1;
        }
      } else {
        if ("No Email" in allTypes) {
          alltypes["No Email"]++;
        } else {
          alltypes["No Email"] = 1;
        }
      }

      return allTypes;
    }, {});

    for (let key in clientTypes) {
      buttons.push(
        <FlatButton
          key={key}
          label={`${key} (${clientTypes[key]})`}
          onClick={this.onClickQuickAdd.bind(this, key)}
        />,
      );
    }

    buttons.push(
      <FlatButton
        key={"All Clients"}
        label={`All Clients (${clients.length})`}
        onClick={this.onClickQuickAdd.bind(this, "All Clients")}
      />,
    );

    return buttons;
  }

  onClickQuickAdd(type) {
    let { clients } = this.state;
    let selected = this.state.selectedClients;
    let addSelection = [];
    let newSelected = [];

    if (type === "No Email") {
      clients.map((client) => {
        if (!client.primary_email__c && selected.indexOf(client) < 0)
          addSelection.push(client);
      });
    } else if (type === "All Clients") {
      clients.map((client) => {
        if (selected.indexOf(client) < 0) addSelection.push(client);
      });
    } else {
      clients.map((client) => {
        if (
          client.record_type__c === type &&
          client.primary_email__c &&
          selected.indexOf(client) < 0
        )
          addSelection.push(client);
      });
    }

    newSelected = selected.concat(addSelection);
    this.setState({ selectedClients: newSelected });
  }

  handleTemplate(e, val) {
    let templates = this.state.templates;
    let template = templates.filter((t) => {
      return t._id === val;
    });
    this.setState({ template: template[0], templateSelection: val });
  }

  handleAttachment(e, val) {
    let { templates, attachments } = this.state;
    let attachment = templates.filter((t) => {
      return t._id === val;
    });
    attachments.push(attachment[0]);
    this.setState({ attachments: attachments, attachmentSelection: "" });
  }

  removeAttachment(i) {
    let { attachments } = this.state;
    delete attachments[i];
    let newAttachments = attachments.map((att) => {
      if (att) return att;
    });
    this.setState({ attachments: newAttachments });
  }

  handleDocument(e, val) {
    let { documents, docTypes } = this.state;
    let doc = docTypes.filter((t) => {
      return t.id === val;
    });
    documents.push(doc[0]);
    this.setState({ documents: documents, documentSelection: "" });
  }

  removeDocument(i) {
    let { documents } = this.state;
    delete documents[i];
    let newDocuments = documents.map((doc) => {
      if (doc) return doc;
    });
    this.setState({ documents: newDocuments });
  }

  clearSelected() {
    this.setState({ selectedClients: [] });
  }

  renderSelection(selection, i) {
    return (
      <MenuItem
        key={selection.id}
        primaryText={selection.name}
        value={selection.id}
      />
    );
  }

  sentFormatter(status) {
    let color;
    if (status !== "success") {
      color = "red";
    }

    return <div style={{ color: color }}>{status}</div>;
  }

  resetForm() {
    this.setState({
      isLoading: true,
      finished: false,
      stepIndex: 0,
      selectedClients: [],
      templates: [],
      template: {},
      attachments: [],
      documents: [],
      templateSelection: "",
      attachmentSelection: "",
      documentSelection: "",
      response: [],
      checkedCount: 0,
    });
    this.populateSelections();
  }

  checkEmail(count) {
    let checkedCount = count > -1 ? count : this.state.checkedCount + 1;
    this.setState({ checkedCount: checkedCount });
  }

  renderAttachment(attachment, i) {
    return (
      <Paper
        className="container"
        key={i}
        style={{ margin: "0.5em", padding: "0.5em", width: "25%" }}
      >
        <center>
          <p>{attachment.name}</p>
          <FlatButton
            label="Remove"
            hoverColor="#ef5350"
            onTouchTap={this.removeAttachment.bind(this, i)}
            style={{ marginRight: 12 }}
          />
        </center>
      </Paper>
    );
  }

  renderDocument(doc, i) {
    return (
      <Paper
        className="container"
        key={i}
        style={{ margin: "0.5em", padding: "0.5em", width: "25%" }}
      >
        <center>
          <p>{doc.name}</p>
          <FlatButton
            label="Remove"
            hoverColor="#ef5350"
            onTouchTap={this.removeDocument.bind(this, i)}
            style={{ marginRight: 12 }}
          />
        </center>
      </Paper>
    );
  }

  render() {
    let {
      stepIndex,
      template,
      clients,
      selectedClients,
      response,
      attachments,
      documents,
    } = this.state;
    let { centerStyle } = this.state.styles;
    let filter1 = { type: "TextFilter", delay: 500 };
    let filter = { type: "TextFilter", delay: 500 };

    if (this.state.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      return (
        <Paper
          className="container"
          zDepth={2}
          style={{
            marginTop: "2em",
            paddingTop: "1em",
            paddingBottom: "1em",
            width: "97%",
          }}
        >
          <Stepper activeStep={stepIndex} orientation="vertical">
            <Step>
              <StepLabel>
                <h4>Choose Clients To Email</h4>
              </StepLabel>
              <StepContent>
                <div className="col-sm-6">
                  <BootstrapTable data={clients} pagination>
                    <TableHeaderColumn
                      dataField="uid__c"
                      dataSort
                      filter={filter1}
                      isKey
                      width="85"
                    >
                      ID
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="name"
                      dataSort
                      filter={filter1}
                    >
                      Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="primary_email__c"
                      dataSort
                      filter={filter1}
                    >
                      Email
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="record_type__c"
                      dataSort
                      filter={filter1}
                      width="100"
                    >
                      Type
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="button"
                      dataFormat={this.addButtonFormatter}
                      width="100"
                    ></TableHeaderColumn>
                  </BootstrapTable>
                  <p>Quck Add</p>
                  {this.quickAddButtons()}
                  <br />
                  <Divider />
                  <br />
                  {this.renderStepActions(0)}
                </div>
                <div className="col-sm-6">
                  <h4>Selected Clients {`(${selectedClients.length})`}</h4>
                  <BootstrapTable data={selectedClients} pagination>
                    <TableHeaderColumn
                      dataField="uid__c"
                      dataSort
                      filter={filter}
                      isKey
                      width="85"
                    >
                      ID
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="name"
                      dataSort
                      filter={filter}
                    >
                      Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="primary_email__c"
                      dataSort
                      filter={filter}
                    >
                      Email
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="button"
                      dataFormat={this.removeButtonFormatter}
                      width="100"
                    ></TableHeaderColumn>
                  </BootstrapTable>
                  <FlatButton
                    hoverColor="#ef5350"
                    label="Clear Selected Clients"
                    onClick={this.clearSelected.bind(this)}
                  />
                </div>
              </StepContent>
            </Step>
            <Step>
              <StepLabel>Email Body and Attachments</StepLabel>
              <StepContent>
                <div style={centerStyle}>
                  <Formsy.Form ref="form">
                    <Subheader>Email Body</Subheader>
                    <FormsySelect
                      name="template"
                      floatingLabelText="Choose Template"
                      value={this.state.templateSelection}
                      onChange={this.handleTemplate}
                    >
                      {this.state.templates
                        .filter((t) => {
                          return t.type === "emailBody";
                        })
                        .map(this.renderSelection)}
                    </FormsySelect>
                    <Divider />
                    <Subheader>Attachment</Subheader>
                    <FormsySelect
                      name="attachment"
                      floatingLabelText="Add Template"
                      value={this.state.attachmentSelection}
                      onChange={this.handleAttachment}
                    >
                      {this.state.templates
                        .filter((t) => {
                          return t.type !== "emailBody";
                        })
                        .map(this.renderSelection)}
                    </FormsySelect>
                    {attachments.map(this.renderAttachment)}
                    <Divider />
                    <Subheader>Documents</Subheader>
                    <FormsySelect
                      name="document"
                      floatingLabelText="Add Document"
                      value={this.state.documentSelection}
                      onChange={this.handleDocument}
                    >
                      {this.state.docTypes.map(this.renderSelection)}
                    </FormsySelect>
                    {documents.map(this.renderDocument)}
                  </Formsy.Form>
                  {this.renderStepActions()}
                </div>
              </StepContent>
            </Step>
            <Step>
              <StepLabel>Preview Email and Attachments</StepLabel>
              <StepContent>
                <CyclePreviews
                  checkEmail={this.checkEmail}
                  clients={selectedClients}
                  template={template}
                  attachments={attachments}
                  documents={documents}
                />
                {this.renderStepActions()}
              </StepContent>
            </Step>
            <Step>
              <StepLabel>Save To Queue</StepLabel>
              <StepContent>
                {response.length == 0 && (
                  <div style={{ margin: "12px 0" }}>
                    <RaisedButton
                      label="Save"
                      disableTouchRipple={true}
                      disableFocusRipple={true}
                      primary={true}
                      onTouchTap={this.sendEmail}
                      style={{ marginRight: 12 }}
                      // disabled={this.state.checkedCount < this.state.selectedClients.length-1}
                    />
                    <FlatButton
                      label="Back"
                      disableTouchRipple={true}
                      disableFocusRipple={true}
                      onTouchTap={this.handlePrev}
                    />
                  </div>
                )}
                {response.length > 0 && (
                  <div>
                    <p>Successfully Queued {response.length} Emails</p>
                    <FlatButton
                      label="Reset Form"
                      onClick={this.resetForm.bind(this)}
                    />
                  </div>
                )}
              </StepContent>
            </Step>
          </Stepper>
        </Paper>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/Email/EmailBuilder.js